import type { QueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

type RosterPublicationDate = {
  readonly year?: number | null;
  readonly month?: number | null;
};

export type InvalidateRosterPublicationCachesParams = {
  readonly curDate: RosterPublicationDate | null | undefined;
  readonly selectedGroupId: string | null | undefined;
  readonly includeAlarms?: boolean;
};

export async function invalidateRosterPublicationCaches(
  queryClient: QueryClient,
  params: InvalidateRosterPublicationCachesParams
): Promise<void> {
  const year = params.curDate?.year;
  const month = params.curDate?.month;

  await queryClient.invalidateQueries({
    queryKey: QUERY_KEYS.roster.versionsScope(year, month),
  });

  await queryClient.invalidateQueries({
    queryKey: QUERY_KEYS.roster.issuedRosterSnapshotScope(
      year != null ? Number(year) : undefined,
      month != null ? Number(month) : undefined
    ),
  });

  await queryClient.invalidateQueries({
    queryKey: QUERY_KEYS.roster.issuedList(params.selectedGroupId),
  });

  if (params.includeAlarms) {
    await queryClient.invalidateQueries({ queryKey: QUERY_KEYS.alarms.list() });
  }
}
